import { render, staticRenderFns } from "./SPRLanguageSelector.vue?vue&type=template&id=6bc707dd"
import script from "./SPRLanguageSelector.vue?vue&type=script&lang=js"
export * from "./SPRLanguageSelector.vue?vue&type=script&lang=js"
import style0 from "./SPRLanguageSelector.vue?vue&type=style&index=0&id=6bc707dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports